import React from "react";
import "../../Css/WhyChoose.css";

const WhyChoose = () => {
  const features = [
    {
      icon: "⚡",
      title: "Fast Development",
    },
    {
      icon: "🎨",
      title: "Modern UI/UX",
    },
    {
      icon: "💰",
      title: "Affordable Pricing",
    },
    {
      icon: "📈",
      title: "Scalable Solutions",
    },
    {
      icon: "📱",
      title: "Responsive Design",
    },
    {
      icon: "🤝",
      title: "Dedicated Support",
    },
  ];

  return (
    <section className="choose-section">
      {/* Background Glow */}
      <div className="choose-glow"></div>

      <div className="choose-container">
        {/* TOP */}
        <div className="choose-top">
          <div className="choose-badge">
            <span className="choose-dot"></span>
            WHY CHOOSE ELITENOVA
          </div>

          <h2 className="choose-title">
            Why Choose <span>EliteNova</span>
          </h2>

          <p className="choose-description">
            What sets us apart from the rest
          </p>
        </div>

        {/* FEATURES */}
        <div className="choose-grid">
          {features.map((item, index) => (
            <div className="choose-card" key={index}>
              <div className="choose-icon">
                {item.icon}
              </div>

              <h3>{item.title}</h3>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChoose;